import { StrictMode } from 'react';

import AppHeader from '@/components/app-header/app-header';
import AppMain from '@/components/app-main/app-main';
import Verification from './components/verification/verification';
import AppFooter from './components/app-footer/app-footer';
import { StringsProvider } from './contexts/strings-context';
import './styles/main.scss';

function App() {
  return (
    <StrictMode>
      <StringsProvider>
        <AppHeader />
        <Verification>
          <AppMain />
        </Verification>
        <AppFooter />
      </StringsProvider>
    </StrictMode>
  );
}

export default App;
